// extracted by mini-css-extract-plugin
export default {"wrapperPage":"Settings_wrapperPage__97KUv","wrapperHeader":"Settings_wrapperHeader__uyysT","title":"Settings_title__hXY1p","wrapperContent":"Settings_wrapperContent__8ZjeP"};